/**
 * mega-menu-shop-by-room.js
 *
 * Keeps the independent Shop by Room menu connected to the live Shopify menu
 * while upgrading the dropdown into an image-led mega menu. Room imagery is
 * loaded only when the menu is opened, avoiding an upfront cost on every page.
 */
(function () {
  'use strict';

  var trigger = document.querySelector('[data-shop-by-room-trigger]');
  var panel = document.querySelector('[data-shop-by-room-panel]');
  var wrapper = trigger && trigger.closest('[data-shop-by-room]');

  if (!trigger || !panel || !wrapper) return;

  var closeTimer = null;
  var imagesLoaded = false;

  function loadImages() {
    if (imagesLoaded) return;

    var images = panel.querySelectorAll('[data-room-image-src]');

    for (var i = 0; i < images.length; i++) {
      var src = images[i].getAttribute('data-room-image-src');

      if (!src) continue;

      images[i].setAttribute('src', src);
      images[i].removeAttribute('data-room-image-src');
    }

    imagesLoaded = true;
  }

  function open() {
    if (closeTimer) {
      clearTimeout(closeTimer);
      closeTimer = null;
    }

    loadImages();
    panel.hidden = false;
    trigger.setAttribute('aria-expanded', 'true');
  }

  function close() {
    panel.hidden = true;
    trigger.setAttribute('aria-expanded', 'false');
  }

  function scheduleClose() {
    if (closeTimer) clearTimeout(closeTimer);

    closeTimer = setTimeout(function () {
      closeTimer = null;
      close();
    }, 180);
  }

  wrapper.addEventListener('pointerenter', open);
  wrapper.addEventListener('pointerleave', scheduleClose);
  panel.addEventListener('pointerenter', open);
  panel.addEventListener('pointerleave', scheduleClose);

  trigger.addEventListener('focus', open);
  panel.addEventListener('focusin', open);

  wrapper.addEventListener('focusout', function () {
    setTimeout(function () {
      if (!wrapper.contains(document.activeElement) && !panel.contains(document.activeElement)) {
        if (closeTimer) {
          clearTimeout(closeTimer);
          closeTimer = null;
        }

        close();
      }
    }, 0);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape' || panel.hidden) return;

    if (closeTimer) {
      clearTimeout(closeTimer);
      closeTimer = null;
    }

    close();
    trigger.focus();
  });
})();
